export default __webpack_public_path__ + "static/media/4.cb5b4671.png";